import * as React from 'react';

import { DeliveryAddressModal } from 'components/address-modal';
import { NoStoresDeliveryModal } from 'components/modal-no-delivery-stores';
import { StoreStatus } from 'remote/api/restaurants';
import { Route, Routes } from 'state/location';
import { relativeRoutes } from 'utils/routing';

interface IDeliveryRoutesProps {
  deliveryModalPath?: string;
}

export const DeliveryRoutes: React.FC<IDeliveryRoutesProps> = ({
  deliveryModalPath = relativeRoutes.address,
}) => {
  return (
    <Routes>
      <Route path={deliveryModalPath} element={<DeliveryAddressModal />} />
      <Route path={relativeRoutes[StoreStatus.NO_DELIVERY]} element={<NoStoresDeliveryModal />} />
    </Routes>
  );
};
